import request from '@/utils/request'

/**
 * 获取二维码
 */
export function getQrCode(data = {}) {
  return request({
    url: '/admin/v1/vehicle/wechat/qrcode/generate',
    method: 'POST',
    data,
  })
}

/**
 * 获取微信二维码状态
 * @param {object} data
 * @param {string} data.id 二维码ID，用以查询二维码状态
 * @param {int[]} customErrorCodes 自定义错误码，不拦截，不弹toast
 */
export function getQrCodeStatus(data = {}, customErrorCodes = []) {
  return request({
    url: '/admin/v1/vehicle/wechat/qrcode/status',
    method: 'POST',
    data,
    headers: {
      // 轮询的业务状态码及错误不拦截，不弹toast
      _che_error_code: customErrorCodes,
    },
  })
}
